import React from 'react';
import './logout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const LogoutPopup = ({ isVisible, onClose, onConfirm, variant = "default", onTakeTest }) => {
  if (!isVisible) return null;

  const isTestVariant = variant === "test";

  return (
    <div className="logout-popup-overlay position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50">
      <div className="logout-popup-container bg-white p-4 rounded position-relative">
        <button className="logout-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="logout-popup-header text-center mb-3">
          <h2>Log out</h2>
        </div>

        <div className="logout-popup-body mb-4">
          {isTestVariant ? (
            <>
              <p>🚀 <strong>Before You Go...</strong></p>
              <p>
                Don’t miss your chance to unlock powerful insights about your leadership potential —
                at <strong>50% off</strong>.
              </p>
              <p>
                Thousands of top professionals have used our psychometric assessment
                to gain clarity, confidence, and stand out to top hiring companies.
              </p>

              <ul
                className="logout-list"
                style={{ listStyle: "none" }}>
                <li>✅ Personalized Leadership Profile</li>
                <li>✅ Get a personalized report with actionable insights</li>
                <li>✅ 50% New User Discount — Limited Time</li>
              </ul>

              <p>🎯 You’re one step away from standing out as a leader.</p>
            </>
          ) : (
            <p>Are you sure you want to log out?</p>
          )}
        </div>

        <div className="logout-popup-actions d-flex justify-content-center gap-3">
          {isTestVariant ? (
            <button className="logout-cancel" onClick={onTakeTest}>
              Take the Assessment
            </button>
          ) : (
            <button className="logout-cancel" onClick={onClose}>
              Cancel
            </button>
          )}

          <button className="logout-approve" onClick={onConfirm}>
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;